export default __webpack_public_path__ + "static/f2-2cb6aa755b53552de62df532e8ca6703.svg";